// @flow
/** @jsx isolateComponent */

import { lighten } from 'polished';

import { Colors } from '@zapier/theme';
import { isolateComponent } from '@zapier/common-utils';

type FilterRuleDividerProps = {
  word: string,
};

const Styles = {
  dividerWord: {
    color: lighten(0.1, Colors.black),
    fontWeight: '600',
    fontSize: '1.1em',
  },
};

const FilterRuleDivider = (props: FilterRuleDividerProps) => {
  const { word } = props;
  return (
    <div css={Styles.dividerWord}>{word.toUpperCase()} continue if&hellip;</div>
  );
};

export default FilterRuleDivider;
